import { defaultAPIFetchOptions } from '@/utils/fetch';
import config from './config';
import { sessionState } from '@/app/sessionState';

function constructOpts(body, withAuth = true) {
  const opts = {
    ...defaultAPIFetchOptions,
    method: 'POST',
    body: JSON.stringify(body),
  };

  opts.headers.Accept = 'application/json';
  opts.headers['Content-Type'] = 'application/json';

  const token = sessionState.token;

  if (withAuth) {
    if (token) {
      opts.headers.Authorization = `Bearer ${token}`;
    } else {
      opts.credentials = 'include';
    }
  }

  return opts;
}

export const track = (eventName, detailOrTitle, detailOrEmpty = {}) => {
  if (!eventName) {
    return;
  }

  let title = '';
  let detail = detailOrEmpty;

  if (typeof detailOrTitle === 'string') {
    title = detailOrTitle;
  } else if (typeof detailOrTitle === 'object') {
    detail = detailOrTitle;
  }

  const opts = constructOpts({
    feature: eventName,
    detail,
    title,
  });

  fetch(`${config.API_URL}/api/featurelog/log`, opts).catch(() => { });
};

const reportError = (args, level) => {
  if (!args.length) {
    return;
  }

  let payload = {};

  payload.host = window.location.hostname;
  payload.level = level;


  for (let i = 0; i < args.length; i++) {
    if (typeof args[i] === 'string' && !payload.message) {
      payload.message = "artfiact:" + args[i];
      continue;
    }

    if (args[i] instanceof Error) {
      payload.message = args[i].message;
      payload.stack = args[i].stack;
      break;
    }
  }

  if (!payload.message) {
    payload.message = "artifact: An unknown error occurred " + window.location.pathname;
    // Try to stringify args and append to message, ignoring errors
    try {
      const argsString = JSON.stringify(args);
      payload.message += " | Args: " + argsString;
    } catch (e) {
      // silently ignore stringify errors
    }
  }


  const opts = constructOpts(payload, false);
  try {
    void fetch(`https://api.adenin.com/api/error/submit`, opts).catch(() => { });
  } catch (e) {
    // silently ignore any synchronous errors from fetchInterceptor
  }
};

export const ErrorReporter = {
  info: (...args) => {
    reportError(args, 'INFO');
  },
  error: (...args) => {
    reportError(args, 'ERROR');
  },
  warn: (...args) => {
    reportError(args, 'WARN');
  },
  debug: (...args) => {
    reportError(args, 'DEBUG');
  },
};
